import React, { useEffect, useRef, useState } from 'react';
import styles from './profileNavBar.module.scss';
import ProfileTabs from '../profileNavBarTabs';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import { achievementsSerializer, getCountEligibleAchievements } from '../achievements/utils';
import { getCountTakenAchievements } from '../impact/utils';

const ProfileNavigationBar = (props) => {
  const elementRef = useRef(null)
  const [width, setWidth] = useState(0)
  // const [hasCollects, setHasCollects] = useState(false);
  const [countEligibleAchievements, setCountEligibleAchievements] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const router = useRouter()
  const { fundraisingStore, authStore, uiStore } = props;

  useEffect(() => {
    const updateCoordinates = () => {
      const element = elementRef.current;
      if (element) {
        const rect = element.getBoundingClientRect();
        setWidth(rect.x + 250);
      }
    };

    updateCoordinates();

    // fundraisingStore?.getProfileCollect()
    //   .then(res => {
    //     setHasCollects(!!res.length)
    //   })
    //   .catch(err => {
    //     setHasCollects(false)
    //   })

    // if(uiStore?.notificationCount === null) {
    authStore?.getAchievements(authStore?.user?.id)
      .then(res => {
        uiStore?.setNotificationCount(getCountEligibleAchievements(res))
        authStore?.setTakenAchievements(getCountTakenAchievements(achievementsSerializer(res)))
        authStore?.setAchievements(achievementsSerializer(res))
      })
      .catch(err => {
        uiStore?.setNotificationCount(0)
      })
      .finally(() => {
        setLoading(false)
      })
    // }

    window.addEventListener('resize', updateCoordinates);

    return () => {
      window.removeEventListener('resize', updateCoordinates);
    };
  }, []);

  const getHeigth = () => {
    if (router.asPath === "/profile/settings/personal/") {
      return props.height ? `${props.height + 240}px` : '1580px'
    }
    if (router.asPath === "/profile/settings/general/") {
      return '1300px'
    }
    if (router.asPath === "/profile/donor_card/") {
      return '900px'
    }
  }

  return (
    <>
      <div className={styles.ProfileNavBar}>
        <div className="container">
          <div ref={elementRef}>
            {
              !isLoading && <ProfileTabs countEligibleAchievements={uiStore?.notificationCount} />
            }
          </div>
          {
            (router.asPath.includes('settings') || router.asPath.includes('donor_card')) &&
            <div className={styles.sidebar} style={{ width: width, height: getHeigth() }}>
              <div className={styles.sidebarContent}>
                <Link href={"/profile/"}>
                  <span className={styles.PersonalSettingsMainBack}>
                    <img src="/static/images/arrows/backProfile.svg" alt="" />
                    Назад
                  </span>
                </Link>
                <h2>Настройки</h2>
                <ul>
                  <li className={router.asPath === "/profile/settings/personal/" && styles.active}><Link href="/profile/settings/personal">Персональные данные</Link></li>
                  <li className={router.asPath === "/profile/settings/general/" && styles.active}><Link href="/profile/settings/general">Управление аккаунтом</Link></li>
                  <li className={router.asPath === "/profile/donor_card/" && styles.active}><Link href="/profile/donor_card">Карточка донора</Link></li>
                </ul>
              </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default inject(
  "fundraisingStore",
  "authStore",
  "uiStore"
)(observer(ProfileNavigationBar));
